import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const VehicleSecurityPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  securityManagerContact,
  complianceOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Vehicle_Security_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Vehicle Security Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        To ensure all vehicles owned or operated by {clientName || "the Company"} are protected against theft, vandalism, and unauthorised access, safeguarding company assets and ensuring operational continuity.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all company vehicles, including HGVs, PSVs, company cars, and trailers.
      </p>

      <h4 className="section-title">3. Vehicle Security Measures</h4>
      <ul>
        <li>All vehicles must be locked and secured when unattended.</li>
        <li>Keys and key fobs must be controlled and never left unattended in vehicles.</li>
        <li>Installation and use of approved alarm and immobiliser systems is mandatory where applicable.</li>
        <li>Vehicles should be parked in secure, well-lit locations, preferably within company premises or authorised parking areas.</li>
        <li>Fuel caps, trailer locks, and other security devices must be engaged properly.</li>
      </ul>

      <h4 className="section-title">4. Driver Responsibilities</h4>
      <ul>
        <li>Drivers must perform pre- and post-shift security checks to ensure vehicles are secure.</li>
        <li>Report any suspicious activity or security breaches immediately to management.</li>
        <li>Follow company procedures for lost or stolen keys or security devices.</li>
      </ul>

      <h4 className="section-title">5. Incident Reporting and Investigation</h4>
      <p className="section-content">
        All thefts, attempted thefts, vandalism, or security breaches must be reported promptly. Investigations will be conducted to identify causes and implement corrective actions.
      </p>

      <h4 className="section-title">6. Training and Awareness</h4>
      <p className="section-content">
        Employees will receive regular training on vehicle security procedures, risk awareness, and reporting mechanisms.
      </p>

      <h4 className="section-title">7. Monitoring and Review</h4>
      <p className="section-content">
        This policy and vehicle security practices will be reviewed regularly to ensure effectiveness and compliance with evolving threats and technologies.
      </p>

      <h4 className="section-title">Roles and Contacts</h4>
      <p><strong>Security Manager:</strong> {securityManagerContact || "[Insert Contact]"}</p>
      <p><strong>Compliance Officer:</strong> {complianceOfficerContact || "[Insert Contact]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Vehicle Security Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default VehicleSecurityPolicy;
